module.exports = __webpack_public_path__ + "static/img/14000572.9ee2302b.png";